module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/icon_exclusive-1d56687d6cc2a8afcd11a984b805325c.png";